import axios from 'axios'

export default {
  load () {
    return axios.get('profile')
  },
  update (user) {
    return axios.put('profile', user)
  }
}
